export enum EstateFormSteps {
  Basics = 'basics',
  Plan = 'plan',
  Detail = 'detail',
  BuildingAccess = 'access',
  BuildingAvailability = 'availability',
  Publish = 'publish',
}
